<template>
  <div id="PrintDialog_main">
    <el-dialog
      title="列印會議前通知資料"
      :visible.sync="dialogVisible"
    >
      <div class="way-select">
        <div
          class="way-div"
          @click="printAssembly()"
        >
          <p>會議通知書</p>
        </div>
        <div
          class="way-div"
          @click="printAttendanceCard()"
        >
          <p>會議條碼</p>
        </div>
        <div
          class="way-div"
          @click="printVotingPaper()"
        >
          <p>投票單（6張/頁）</p>
        </div>
        <div
          class="way-div"
          @click="printVotingPaperBig()"
        >
          <p>投票單（2張/頁）</p>
        </div>
      </div>
    </el-dialog>
    <PrintAssembly ref="printAssembly" />
    <PrintAttendanceCard ref="printAttendanceCard" />
    <PrintVotingPaper ref="printVotingPaper" />
    <PrintVotingPaperBig ref="printVotingPaperBig" />
  </div>
</template>
<script>
import PrintAttendanceCard from './PrintAttendanceCard'
import PrintAssembly from './PrintAssembly'
import PrintVotingPaper from './PrintVotingPaper'
import PrintVotingPaperBig from './PrintVotingPaperBig'

export default {
  components: {
    PrintAssembly,
    PrintAttendanceCard,
    PrintVotingPaper,
    PrintVotingPaperBig
  },
  data () {
    return {
      dialogVisible: false,
      assemblyData: {},
      topicList: [],
      assemblyId: '',
      fromList: true,
      title: '' // 會議標題
    }
  },
  methods: {
    // 由會議列表開啟
    openPrintDialogFromList (assemblyId, title) {
      this.dialogVisible = true
      this.assemblyId = assemblyId
      this.fromList = true
      this.title = title
    },
    // 由會議檢視開啟
    openPrintDialogFromDetail (assemblyData, topicList) {
      console.log(assemblyData)
      this.dialogVisible = true
      this.assemblyData = assemblyData
      this.title = assemblyData.title
      this.topicList = topicList
      this.assemblyId = assemblyData.id
      this.fromList = false
    },
    // 列印會議通知書
    printAssembly () {
      if (this.fromList) { this.$refs.printAssembly.getAssembly(this.assemblyId) } else { this.$refs.printAssembly.print(this.assemblyData, this.topicList) }
    },
    // 列印會議條碼
    printAttendanceCard () {
      this.$refs.printAttendanceCard.print(this.assemblyId, this.title)
    },
    // 列印投票單，無選擇議案列表彈窗
    printVotingPaper () {
      this.$refs.printVotingPaper.print(this.assemblyId, this.title)
    },
    // 列印投票單，無選擇議案列表彈窗（大）
    printVotingPaperBig () {
      this.$refs.printVotingPaperBig.print(this.assemblyId, this.title)
    }
  }
}
</script>
<style lang="sass" scoped>
#PrintDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    width: 65%
    .el-dialog__body
      padding: 20px 0
    .way-select
      justify-content: center
      .way-div
        margin: 20px 10px
        border: 1px solid $borderDark2
        border-radius: 8px
        padding: 40px
        cursor: pointer
        display: inline-block
        width: 302px
        &:hover
          background-color: $defaultColorHover
          border: 1px solid $borderDark1
        p
          font-size: 28px
          line-height: 40px
          font-weight: bold
          color: $subFontColor
</style>
